/** @jsxImportSource @emotion/react */
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import PhysicianTab from '../Physician.tab'

import { Order } from 'store/types'

interface IProps {
  order: Order
  open: boolean
  onClose: () => void
  refetchOrder: () => void
}

export const UpdatePhysicianModal = ({ order, open, onClose, refetchOrder }: IProps) => {
  return (
    <Modal centered show={open} onHide={onClose} size="lg" css={{ zIndex: 1040 }}>
      <Modal.Header>
        <Modal.Title>EDIT PHYSICIAN INFORMATION</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PhysicianTab order={order} onModify={onClose} refetchOrder={refetchOrder} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
